// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 
 */
import logoDark from 'assets/images/logo-dark.svg';
import logo from 'assets/images/logo.001.png';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();

    return (
        <img src={theme.palette.mode === 'dark' ? logoDark : logo} alt="Back Stage" style={{height:35,verticalAlign:'middle'}} />
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={theme.palette.mode === 'dark' ? logoDark : logo} alt="Berry" width="100" />
         *
         */
    );
};

export default Logo;
